__turbopack_context__.v({
  "answer": "faqSection-module__LkfR2W__answer",
  "badge": "faqSection-module__LkfR2W__badge",
  "blogAnswer": "faqSection-module__LkfR2W__blogAnswer",
  "blogArticleWrap": "faqSection-module__LkfR2W__blogArticleWrap",
  "blogBadge": "faqSection-module__LkfR2W__blogBadge",
  "blogBody": "faqSection-module__LkfR2W__blogBody",
  "blogCard": "faqSection-module__LkfR2W__blogCard",
  "blogCardActive": "faqSection-module__LkfR2W__blogCardActive",
  "blogCountBadge": "faqSection-module__LkfR2W__blogCountBadge",
  "blogExpandIcon": "faqSection-module__LkfR2W__blogExpandIcon",
  "blogFaqFadeIn": "faqSection-module__LkfR2W__blogFaqFadeIn",
  "blogGrid": "faqSection-module__LkfR2W__blogGrid",
  "blogHeaderBtn": "faqSection-module__LkfR2W__blogHeaderBtn",
  "blogHeaderSection": "faqSection-module__LkfR2W__blogHeaderSection",
  "blogQuestion": "faqSection-module__LkfR2W__blogQuestion",
  "blogSection": "faqSection-module__LkfR2W__blogSection",
  "blogTitle": "faqSection-module__LkfR2W__blogTitle",
  "blogTitleRow": "faqSection-module__LkfR2W__blogTitleRow",
  "blogTitleWrap": "faqSection-module__LkfR2W__blogTitleWrap",
  "blogToggleButton": "faqSection-module__LkfR2W__blogToggleButton",
  "blogToggleWrapper": "faqSection-module__LkfR2W__blogToggleWrapper",
  "countBadge": "faqSection-module__LkfR2W__countBadge",
  "expandIcon": "faqSection-module__LkfR2W__expandIcon",
  "fadeIn": "faqSection-module__LkfR2W__fadeIn",
  "faqBody": "faqSection-module__LkfR2W__faqBody",
  "faqCard": "faqSection-module__LkfR2W__faqCard",
  "faqCardActive": "faqSection-module__LkfR2W__faqCardActive",
  "faqGrid": "faqSection-module__LkfR2W__faqGrid",
  "faqHeader": "faqSection-module__LkfR2W__faqHeader",
  "headerSection": "faqSection-module__LkfR2W__headerSection",
  "iconStacked": "faqSection-module__LkfR2W__iconStacked",
  "iconWide": "faqSection-module__LkfR2W__iconWide",
  "inArticleWrapper": "faqSection-module__LkfR2W__inArticleWrapper",
  "question": "faqSection-module__LkfR2W__question",
  "section": "faqSection-module__LkfR2W__section",
  "title": "faqSection-module__LkfR2W__title",
  "titleRow": "faqSection-module__LkfR2W__titleRow",
  "titleWrap": "faqSection-module__LkfR2W__titleWrap",
  "toggleButton": "faqSection-module__LkfR2W__toggleButton",
  "toggleWrapper": "faqSection-module__LkfR2W__toggleWrapper",
  "wideOnlyOpen": "faqSection-module__LkfR2W__wideOnlyOpen",
});
